import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRightIcon } from 'shared/ui/icons';
import { ToggleTranslateButton } from 'shared/ui/toggle-translate-button';
import COLORS from 'shared/design-tokens/colors';
import { RoleFormPanel } from '../components/role-form-panel';

/**
 * Route-level page for /management-role/create-role and /management-role/edit-role/:id.
 * Rendered directly by React Router — may use the Page suffix.
 */
const RoleFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div className="md:overflow-auto">
      <div className="w-full pt-8 px-6 pb-4 gap-y-2 flex flex-wrap items-center">
        <div className="w-1/2">
          <nav
            aria-label="Breadcrumb"
            className="w-full flex items-center gap-2"
          >
            <button
              type="button"
              className="text-sm font-normal text-slate-500 cursor-pointer hover:text-slate-800"
              onClick={() => navigate('/management-role')}
              aria-label={t('role')}
            >
              {t('role')}
            </button>
            <ArrowRightIcon color={COLORS.slate500} />
            <span className="text-sm font-medium text-slate-700">
              {id ? t('edit') : t('create')} {t('role')}
            </span>
          </nav>
          <div className="w-full flex flex-wrap">
            <div className="w-1/2">
              <p className="font-semibold text-2xl">
                {id ? t('edit') : t('create')} {t('role')}
              </p>
            </div>
          </div>
        </div>
        <div className="w-1/2 flex justify-end px-6 gap-2">
          <ToggleTranslateButton className="!h-10" />
        </div>
      </div>

      <div className="flex flex-col flex-grow justify-start px-6 bg-neutral-25">
        <RoleFormPanel id={id} />
      </div>
    </div>
  );
};

export default RoleFormPage;
